module.exports = __webpack_public_path__ + "static/media/ipsum.eb27e03c.png";